export default "__VITE_ASSET__Dt4Nkv97__"